import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    emanuelWeb: [],
    carEmanuel: [],
    tokenEmanuel: ""
  },
  mutations: {
    login(state, data) {
      state.emanuelWeb = data.user;
      state.tokenEmanuel = data.tokenEmanuel;
    },
    logout(state) {
      state.emanuelWeb = null;
      state.carEmanuel = [];
      state.tokenEmanuel = "";
    },
    perfil(state, data) {
      state.emanuelWeb = data;
    },
    datos(state, data) {
      state.emanuelWeb = data;
    },
    image(state, data) {
      state.emanuelWeb = data;
    },
    carrito(state, articulo) {
      let cambio = false;
      if (state.carEmanuel.length === 0) {
        state.carEmanuel.push(articulo);
      } else {
        for (let i = 0; i < state.carEmanuel.length; i++) {
          if (state.carEmanuel[i]._id === articulo._id) {
            state.carEmanuel[i].cant = state.carEmanuel[i].cant + articulo.cant;
            cambio = true;
          }
        }
        if (cambio === false) {
          state.carEmanuel.push(articulo);
        }
      }
    },
    agc(state, articulo) {
      let cambio = false;
      if (state.carEmanuel.length === 0) {
        state.carEmanuel.push(articulo);
      } else {
        for (let i = 0; i < state.carEmanuel.length; i++) {
          if (state.carEmanuel[i]._id === articulo._id) {
            state.carEmanuel[i].cant = state.carEmanuel[i].cant + 1;
            cambio = true;
          }
        }
        if (cambio === false) {
          state.carEmanuel.push(articulo);
        }
      }
    },
    modificarcarrito(state, data) {
      for (let i = 0; i < state.carEmanuel.length; i++) {
        if (state.carEmanuel[i]._id === data._id) {
          state.carEmanuel[i].cant--;
        }
        if (state.carEmanuel[i].cant === 0) {
          state.carEmanuel.splice(i, 1);
        }
      }
    },
    sumar(state, articulo) {
      for (let i = 0; i < state.carEmanuel.length; i++) {
        if (state.carEmanuel[i]._id === articulo._id) {
          state.carEmanuel[i].cant++;
        }
      }
    },
    carrito2(state, articulo) {
      for (let i = 0; i < state.carEmanuel.length; i++) {
        if (state.carEmanuel[i]._id === articulo._id) {
          state.carEmanuel[i].cant = state.carEmanuel[i].cant + articulo.cant;
        }
      }
    },
    eliminar(state, articulo) {
      for (let i = 0; i < state.carEmanuel.length; i++) {
        if (state.carEmanuel[i]._id === articulo._id) {
          state.carEmanuel.splice(i, 1)
        }
      }
    },
    vaciarcarrito(state) {
      state.carEmanuel = [];
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    modificarperfil({ commit }, data) {
      commit("perfil", data);
    },
    obtdatos({ commit }, data) {
      commit("datos", data);
    },
    image({ commit }, data) {
      commit("image", data);
    },
    agregarcarrito({ commit }, articulo) {
      commit("carrito", articulo);
    },
    modificarcarrito({ commit }, data) {
      commit("modificarcarrito", data);
    },
    sumar({ commit }, data) {
      commit("sumar", data);
    },
    agregarcarrito2({ commit }, articulo) {
      commit("carrito2", articulo);
    },
    vaciarcarrito({ commit }) {
      commit("vaciarcarrito");
    },
    eliminar({ commit }, data) {
      commit("eliminar", data);
    },
    agc({ commit }, articulo) {
      commit("agc", articulo);
    }
  }
});
